import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="-0.625 -0.625 24 24"
        id="Recycle-Bin-2--Streamline-Flex"
        height="24"
        width="24"
    >
        <g id="recycle-bin-2--remove-delete-empty-bin-trash-garbage">
            <path
                id="Vector 195"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.4375 6.51821625c6.01615625 -0.79129375 11.85884375 -0.79129375 17.875 0"
                strokeWidth="1.25"
            ></path>
            <path
                id="Subtract"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.03183625 6.32662875c-0.056728749999999994 3.0369462499999997 -0.1355575 8.169931250000001 0.80548 12.36639625 0.36430875 1.6245125 1.7471675 2.7867125 3.39573 3.0190875000000004 1.06562625 0.1503125 2.0371650000000003 0.2253875 3.14211625 0.2253875 1.105 0 2.076685 -0.075075 3.1424575000000003 -0.2253875 1.6485625 -0.23237499999999997 3.031405 -1.394575 3.39573 -3.0190875000000004 0.9410375 -4.1964162499999995 0.8622249999999999 -9.32936875 0.8055125 -12.36633125 -4.9279262500000005 -0.53590875 -9.75914875 -0.53594125 -14.687026249999999 -0.00006500000000000001Z"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.1790225 6.01757c-0.012545 -0.16417374999999998 -0.01886625 -0.81631875 -0.01886625 -0.9904212499999999C7.16015625 2.32977875 8.677435 0.8125 11.374805 0.8125s4.21464875 1.51727875 4.21464875 4.21464875c0 0.1741025 -0.00632125 0.8262475 -0.0188825 0.9904212499999999"
                strokeWidth="1.25"
            ></path>
            <path
                id="Subtract_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.68985 10.40663c-0.09600500000000001 1.700075 -0.00078 4.71537625 0.294645 6.8919825m4.7802299999999995 0c0.29534375 -2.17667125 0.3904225 -5.1919562500000005 0.29440125 -6.89203125"
                strokeWidth="1.25"
            ></path>
        </g>
    </svg>,
) as React.FC<{ className?: string }>;
